import { render, staticRenderFns } from "./ShowMemberNews.vue?vue&type=template&id=d3fbc054&scoped=true"
import script from "./ShowMemberNews.vue?vue&type=script&lang=js"
export * from "./ShowMemberNews.vue?vue&type=script&lang=js"
import style0 from "./ShowMemberNews.vue?vue&type=style&index=0&id=d3fbc054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fbc054",
  null
  
)

export default component.exports